<template>
	<div class="mia-flipCard" :class="{ reverted: isFlipped }" @click="isFlipped = !isFlipped">
		<div class="mia-flipCard-inner">
			<div class="mia-frontSide">
				<h4 v-tr="headerTr" />
				<h5 v-tr="'learnmore_with_arrow'" class="mia-learnMore" />
				<responsive-image v-if="icon" :from="icon" />
			</div>
			<div class="mia-backSide">
				<h4 v-tr="headerTr" />
				<p v-tr="descriptionTr" />
				<a v-tr="buttonTextTr" :href="buttonLink" class="btn mia-btn-primary" />
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import ResponsiveImage from "@/Control/Vue/ResponsiveImage";
import { MiaPlaza } from "../../Reinforced.Typings";

@Component({
	components: {
		ResponsiveImage,
	},
})
export class FlipCard extends Vue {
	@Prop({ required: true }) headerTr!: string;
	@Prop({ required: true }) descriptionTr!: string;
	@Prop({ required: true }) buttonTextTr!: string;
	@Prop({ required: true }) buttonLink!: string;
	@Prop({ required: false }) icon!: MiaPlaza.Navigation.JSON.Converters.ILazySizes;

	isFlipped = false;
}

export default toNative(FlipCard);
</script>
